
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#000000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M.751 13.509l11.25 7.826 11.25-7.826"}}),_c('path',{attrs:{"d":"M.751 3.314c0-.538.361-.727.8-.42L11.2 9.6a1.513 1.513 0 001.607 0l9.643-6.709c.442-.307.8-.118.8.42v3.3a2.1 2.1 0 01-.8 1.537l-9.65 6.716a1.517 1.517 0 01-1.607 0L1.554 8.155a2.1 2.1 0 01-.8-1.537z"}})])])
          )
        }
      }
    